import MainPreferencesView from "./MainPreferencesView"
export default MainPreferencesView
